/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useParams } from "react-router-dom";
import { useUserConsumer } from "~/context/User/User";
import { isPrivilegedUser } from "~/routing";
import { generateActionSuccessText, useAxios } from "~/tools";
import { useShowError } from "../Error/useShowError";
import { ServiceIdRouteParams } from "../Services/types";
import { showSuccess } from "../Toast";

export function useSLANameModification(
  slaId: string,
  refetch?: (id?: string | undefined) => Promise<void>
) {
  const state = useParams<ServiceIdRouteParams>();
  const { serviceId } = state;

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const onSubmit = async (input: { name: string }) => {
    try {
      await Axios().put(`/catalog/services/${serviceId}/slas/${slaId}`, input);
      showSuccess(generateActionSuccessText("SLA ")()("updated")());
    } catch (e) {
      showError(e.response);
    } finally {
      refetch && refetch();
    }
  };

  const { role } = useUserConsumer();

  const isNameEditorEnabled = isPrivilegedUser(role) && serviceId !== undefined;

  return {
    onSubmit,
    isNameEditorEnabled,
  };
}
